import { IonGrid, IonRow } from '@ionic/react';

import styles from './ClientSelectionCard.module.css';

import { Card } from './Card';

interface clientSelectionCardProps {
  firstName: string;
  lastName: string;
  id: string;
  handleClientSelection: (clientId: string) => void;
  selectedClient: boolean;
}

export const ClientSelectionCard = ({
  firstName,
  lastName,
  id,
  handleClientSelection,
  selectedClient,
}: clientSelectionCardProps) => {
  return (
    <>
      <Card
        className={selectedClient ? styles.selected : styles.card}
        onClick={() => {
          console.log('Client selected:', firstName, lastName, id);
          handleClientSelection(id);
        }}>
        <IonGrid>
          <IonRow className={styles.sectionHeader}>
            {firstName} {lastName}
          </IonRow>
        </IonGrid>
      </Card>
    </>
  );
};
